import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { LibraryCategory } from 'types';
import { providesList } from 'utils/query-cache';

import { apiQuery } from '../../query';

import { CategoryListResponse } from './types';

const categoryType = 'CATEGORIES' as const;

export const categoriesApi = createApi({
  baseQuery: apiQuery,
  tagTypes: [categoryType],
  reducerPath: 'categoriesApi',
  endpoints: (build) => ({
    list: build.query<LibraryCategory[], void>({
      providesTags: providesList(categoryType),
      transformResponse: (response: CategoryListResponse) => response.data,
      query: () => ({
        method: 'get',
        url: URL.LIBRARY_CATEGORIES,
      }),
    }),
  }),
});

export const { useListQuery: useCategoriesListQuery } = categoriesApi;

export type { CategoryListResponse };
